import React from 'react'

export const MediaLoadedContext = React.createContext(null)

const MediaLoadedProvider = ({ children }) => {
  const [doneUploading, setDoneUploading] = React.useState(true)

  return (
    <MediaLoadedContext.Provider value={{ doneUploading, setDoneUploading }}>
      {children}
    </MediaLoadedContext.Provider>
  )
}

export default MediaLoadedProvider

export function useMediaLoaded () {
  return React.useContext(MediaLoadedContext)
}
